import React from 'react'
import MedicalReport from '../../../Components/UserComponents/MedicalReport/MedicalReport'

const MedicalReportPage = () => {
    return (
        <div>
            <MedicalReport />
        </div>
    )
}

export default MedicalReportPage